const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://tb9acn8re8.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://3z0t5l8bt4.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.staging.valeglobal.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.2',
    HOSTNAME: 'https://targets.staging.valeglobal.forwoodsafety.com'
  }
};

export default config;